import type {CompletedReview} from '../../../../../page-data/payloads/review-requests'
import styles from './ReviewHeaderContent.module.css'
import {ReviewerLink} from './ReviewerLink'

interface ReviewHeaderDescriptionProps {
  reviews: CompletedReview[]
}

/**
 * Renders the description (reviewer identities) for a review group header:
 * - 1 reviewer: nothing (identity is shown inline in the title)
 * - 2 reviewers: <Identity> and <Identity>
 * - 3 reviewers: <Identity>, <Identity>, and <Identity>
 * - 4+ reviewers: <Identity>, <Identity>, and N-2 others
 */
export function ReviewHeaderDescription({reviews}: ReviewHeaderDescriptionProps) {
  const count = reviews.length
  const [first, second, third] = reviews

  if (count < 2 || !first || !second) {
    return null
  }

  if (count === 2) {
    return (
      <span className={styles.description}>
        <span className={styles.reviewerIdentityWrapper}>
          <ReviewerLink reviewer={first.reviewer} />
        </span>
        <span>and</span>
        <span className={styles.reviewerIdentityWrapper}>
          <ReviewerLink reviewer={second.reviewer} />
        </span>
      </span>
    )
  }

  if (count === 3 && third) {
    return (
      <span className={styles.description}>
        <span className={styles.reviewerIdentityWrapper}>
          <ReviewerLink reviewer={first.reviewer} />
          <span>,</span>
        </span>
        <span className={styles.reviewerIdentityWrapper}>
          <ReviewerLink reviewer={second.reviewer} />
          <span>, and</span>
        </span>
        <span className={styles.reviewerIdentityWrapper}>
          <ReviewerLink reviewer={third.reviewer} />
        </span>
      </span>
    )
  }

  // 4+ reviewers: show first two + "and N-2 others"
  return (
    <span className={styles.description}>
      <span className={styles.reviewerIdentityWrapper}>
        <ReviewerLink reviewer={first.reviewer} />
        <span>,</span>
      </span>
      <span className={styles.reviewerIdentityWrapper}>
        <ReviewerLink reviewer={second.reviewer} />
        {`, and ${count - 2} others`}
      </span>
    </span>
  )
}
